module.exports = __webpack_public_path__ + "static/media/ODS10.dd28b742.jpg";